module.exports = __webpack_public_path__ + "static/media/blue.1543d792.png";